import React, { useEffect, useState } from 'react'
import CustomRadioButton from '../../common/CustomRadioButton'
import removeIcon from "../../../images/product-question/remove.svg"
import disabledRemoveIcon from "../../../images/product-question/disabled-remove.svg"
import uploadPlus from "../../../images/product-question/upload-plus.svg"
import { toast } from 'react-toastify'

const MultiQuestions = ({
  queNo,
  quesId,
  question,
  setQuestionsValue,
  handleRemoveQuestion,
  handleChange,
  handleOptionChange,
  handleOptionRadioChange,
  handleSubmit,
  error,
  answerEor,
  setAnswerError
}) => {

  const [flag, setFlag] = useState(false);



  const handleAddOption = () => {
    const a = {
      optionId: null,
      answerText: "",
      isCorrect: false
    }
    question.answerOptions.push(a)

    setFlag(!flag)
  }


  const handleRemoveOption = (index) => {

    question.answerOptions.splice(index, 1)
    setFlag(!flag)

    // question.answerOptions[0].isCorrect = true;

    document.querySelectorAll('.ProductQuestionsSec .main-questions-area .questionWrapper .AnsInputGrid .AnsInputItem .form-check label.radio-label input[type=radio]:checked').forEach((radioInput, optionIndex) => {
      // Get the computed style of the radio input element
      const style = window.getComputedStyle(radioInput);

      // Check if the background image matches the one we're looking for
      if (style.backgroundImage.includes("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGySURBVHgBtVYBkYMwEDxeARIioRIqoRLqABwQB60DcNA6qITWAaCAd3CfTS/MkQcamOnO3A+EwN5t9u5LtI7cReXi4aJ1wRKDrJUuDO2AkQ9wYtS0gaiQDDnPcy7Lkm+3G7dtywHP59Ovnc9njqoqP328Ci+cTicehoE/AcQRUbWWud90uVx4K6qq0iT/KjFBFmzcCySm5DKaAIfkS40Bmay1fDwexwwPhwM3TTNLAmll30Nn7xf1QQK4N8YsugfP4neQEMwhe2Bzr9ds9msf1ySxGeA8eW5JSvG206jrOrUHvIQa9/t9IpM/XHhbAzqnEuB8YmnlWZvJBbl1feiUZRltwdL7P/RlgKDDRdd1kweubEqFk3Ny/3q9wuXvSKAWNxMURTG57/t+5MIf68JbK/Zzqk1jqNnkRwaawTdH7Oc9jaYchDChFPjVt/kc0BPatrAlZtbctFXZ11o2MPl+uF6vvBdoOFoYdiR6zXZmCpAYrYzrABs2odRY3zlAJjVBx/mzhjLIFYgwp/QoATHW4Dw1OZP+ZZI6k4YSZxG9TWJoB4xk9dBV0fsnDNYsycxfwh+F5XJ6kBI+/AAAAABJRU5ErkJggg==")) {
        console.log(`Found matching background for radio option ${optionIndex}`);

        // Assuming `question.answerOptions` exists and you want to set `isCorrect` for this option
        if (question.answerOptions[optionIndex]) {
          question.answerOptions[optionIndex].isCorrect = true;
          console.log(`Option ${optionIndex} is set as correct`);
        }
      }
    });


  }

  useEffect(() => {



  }, [flag])



  return (
    <>
      <div className='questionWrapper'>

        <div className="InputWrapper">
          <label>{queNo} Question : </label>
          <div class="InputField">
            <input
              type="text"
              className="form-control"
              name={`questions[${quesId}]`}
              value={question.questionText}
              onChange={(e) => {
                handleChange(quesId, e.target.value);
              }}
            />
            <p className="error">{error}</p>
          </div>
        </div>

        <div className='InputWrapper'>
          <label>Ans : </label>
          <div className='AnsInputGridWrapper'>
            {
              question?.answerOptions?.map((op, index) => (
                console.log("ooooo", op),
                <div className="AnsInputGrid" key={index}>
                  <div className="AnsInputItem">
                    <div>( {String.fromCharCode(65 + index)} )</div>
                  </div>
                  <div className="AnsInputErrorWrapper">
                    <div className="AnsInnerInputGridWrapper">
                      <div class="InputField">
                        <input
                          type="text"
                          className="form-control"
                          name={`option1${quesId}`}
                          value={op.answerText}
                          onChange={(e) => {
                        // console.log(e.target.value,"e.target.value")
                            handleOptionChange(quesId, index, e.target.value);
                        // const newValue = e.target.value;

                        // Check if the new value matches any other existing option
                        // const isDuplicate = question?.answerOptions.some(
                        //   (opt, optIndex) => optIndex !== index && opt.answerText === newValue
                        // );
                        // if (!isDuplicate) {
                        //   handleOptionChange(quesId, index, newValue);
                        // } else {
                        //   // alert("Answer options cannot be the same!");
                        //   toast.error("Answer options cannot be the same! ")
                        // }
                          }}
                        />
                      </div>
                      <div className="AnsInputItem">
                        <div className="form-check">
                          <label>
                            <CustomRadioButton
                              type="radio"
                              name={`multiOp${op?.optionId}`}
                              value={op.isCorrect}
                              checked={op.isCorrect === true ? true : false}
                              onChange={() => {
                                handleOptionRadioChange(queNo - 1, quesId, index);
                              }}
                            />
                          </label>
                        </div>
                      </div>

                      <div className="AnsInputItem" >
                        <i class={`fa-regular fa-circle-xmark ${question.answerOptions?.length == 2
                          ? "pe-none"
                          : "cursor-pointer"
                          }`} onClick={() => handleRemoveOption(index)} />
                        {/* <img
                      src={
                        question.answerOptions?.length == 2
                          ? disabledRemoveIcon
                          : removeIcon
                      }
                      className={`fa fa-circle-plus remove-icon-image ${
                        question.answerOptions?.length == 2
                          ? "pe-none"
                          : "cursor-pointer"
                      }`}
                      onClick={() => handleRemoveOption(index)}
                    /> */}
                      </div>
                    </div>
                    <p className="error">{answerEor}</p>
                  </div>
                </div>
              ))

            }

          </div>
        </div>

        <div className="add-question">
          <p
            className={`${question?.answerOptions?.length == 4 && "disabled"}`}
            onClick={() => handleAddOption()}
          >
            + Add Option
          </p>
        </div>

        {/* <div className="remove-new-module-btn">
          <p
            onClick={() => {
              handleRemoveQuestion(quesId);
            }}
          >
            -  Update Question 
          </p>
             </div> */}
      </div>
    </>
  )
}

export default MultiQuestions